import { LanguagePipe } from './language.pipe';
import { PhonePipe } from './phone.pipe';

export const pipes = [LanguagePipe, PhonePipe]


export * from './language.pipe';
export * from './phone.pipe';
